define([
    "./monitoringNodeCommandsModule"
], function (module) {
    "use strict";

    return module.service("nodeCommandTransitionFinalize", ["transitionService", "attachmentMandatoryModal", function (transitionService, attachmentMandatoryModal) {
        return function (selection, context) {

            let transitionNode = selection[0];
            if (transitionNode.type.monitorableNodeType !== "INVOICE") {
                return accomplishTransition(transitionNode.id, context);
            }
            return transitionService.isAttachmentRequired().then(function (isAttachmentRequired) {
                if (isAttachmentRequired) {
                    return attachmentMandatoryModal(transitionNode.id)
                        .then(function () {
                            return context.refilter();
                        });
                }
                return accomplishTransition(transitionNode.id, context);
            })
        };

        function accomplishTransition(transitionId, context) {
            return transitionService.accomplishTransitions([transitionId]).then(function () {
                return context.refilter();
            });
        }

    }]);
});